import { axiosNewAjax, axiosAjax } from '@/utils/ajax'
export default class classCourseApi{
    static getClassList(data){
        return axiosAjax('get','/studyapp-service/trainClass/getPersonalTrainClassList',data)
    }
}


// WEBPACK FOOTER //
// ./src/api/classCourseApi.js